var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound container"},[_c('div',{staticClass:"main_heading"},[_vm._v("Sorry, this page not found")]),_c('router-link',{staticClass:"red_btn",attrs:{"to":"/"}},[_vm._v("Back to home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }